import { render, staticRenderFns } from "./ResetPasswordV2.vue?vue&type=template&id=320a1652"
import script from "./ResetPasswordV2.vue?vue&type=script&lang=js"
export * from "./ResetPasswordV2.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordV2.vue?vue&type=style&index=0&id=320a1652&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports